import Pagination from './Pagination';
export default Pagination;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/pagination/index.js
// module id = 201
// module chunks = 0